﻿<template>
  <nav class="universal-nav-bar">
    <div class="nav-container">
      <!-- 主页按钮 (自选股) -->
      <router-link to="/watchlist" class="nav-item home-btn" title="主页">
        <svg class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <polyline points="9 22 9 12 15 12 15 22" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="nav-text">主页</span>
      </router-link>

      <!-- 策略组 -->
      <router-link to="/strategy-groups" class="nav-item" title="策略组">
        <svg class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <rect x="3" y="3" width="7" height="7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <rect x="14" y="3" width="7" height="7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <rect x="14" y="14" width="7" height="7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <rect x="3" y="14" width="7" height="7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="nav-text">策略组</span>
      </router-link>

      <!-- 计划 -->
      <router-link to="/plans" class="nav-item" title="计划">
        <svg class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="nav-text">计划</span>
      </router-link>

      <!-- 持仓 -->
      <router-link to="/positions" class="nav-item" title="持仓">
        <svg class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <rect x="1" y="4" width="22" height="16" rx="2" ry="2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <line x1="1" y1="10" x2="23" y2="10" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="nav-text">持仓</span>
      </router-link>

      <!-- 复盘 -->
      <router-link to="/trade-review" class="nav-item" title="复盘">
        <svg class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <polyline points="1 4 1 10 7 10" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="nav-text">复盘</span>
      </router-link>

      <!-- 训练 -->
      <router-link to="/training" class="nav-item" title="训练">
        <svg class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path d="M12 3v18" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M5 8c4 0 7 3 7 7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M19 8c-4 0-7 3-7 7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M7 19h10" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="nav-text">训练</span>
      </router-link>

      <!-- 龙头 -->
      <router-link to="/sector-leaders" class="nav-item" title="龙头">
        <svg class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="nav-text">龙头</span>
      </router-link>

      <!-- 龙虎榜 -->
      <router-link to="/dragon-tiger" class="nav-item" title="龙虎">
        <svg class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path d="M12 2L2 7l10 5 10-5-10-5z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M12 22v-9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M2.5 9v10" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M21.5 9v10" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="nav-text">龙虎</span>
      </router-link>

      <!-- 重点 -->
      <router-link to="/key-stocks" class="nav-item" title="重点">
        <svg class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path d="M12 2L2 7l10 5 10-5-10-5z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M2 17l10 5 10-5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M2 12l10 5 10-5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="nav-text">重点</span>
      </router-link>

      <!-- 管理 -->
      <router-link v-if="isAdmin" to="/admin" class="nav-item" title="管理">
        <svg class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <circle cx="12" cy="12" r="3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M12 1v6m0 6v6m5.196-15.196l-4.242 4.242m-5.908 5.908l-4.242 4.242m15.196 0l-4.242-4.242m-5.908-5.908l-4.242-4.242" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="nav-text">管理</span>
      </router-link>

      <!-- 回测 -->
      <router-link to="/advanced-backtest" class="nav-item" title="回测">
        <svg class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <line x1="12" y1="1" x2="12" y2="23" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="nav-text">回测</span>
      </router-link>

      <!-- 产业研究 -->
      <router-link to="/research" class="nav-item" title="产业研究">
        <svg class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M8 7h8M8 11h8M8 15h5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="nav-text">产业研究</span>
      </router-link>

      <!-- 挖掘 -->
      <router-link to="/pattern-mining" class="nav-item" title="挖掘">
        <svg class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <circle cx="11" cy="11" r="8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="m21 21-4.35-4.35" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="nav-text">挖掘</span>
      </router-link>

      <!-- 基金 -->
      <router-link to="/fund-portfolio" class="nav-item" title="基金">
        <svg class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <circle cx="12" cy="12" r="10" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="nav-text">基金</span>
      </router-link>

      <!-- 缠论 -->
      <router-link to="/chan-theory" class="nav-item" title="缠论">
        <svg class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
        </svg>
        <span class="nav-text">缠论</span>
      </router-link>

      <!-- 热点 -->
      <router-link to="/hot-news" class="nav-item" title="热点">
        <div class="relative">
             <svg class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z" />
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.879 16.121A3 3 0 1012.015 11L11 14H9c0 .768.293 1.536.879 2.121z" />
            </svg>
            <span v-if="unreadCount > 0" class="nav-badge">
              {{ formattedUnreadCount }}
            </span>
        </div>
        <span class="nav-text">热点</span>
      </router-link>
    </div>
  </nav>
</template>

<script setup>
import { computed, onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useNotificationStore } from '@/stores/notification'
import { newsApi } from '@/api/client'

const authStore = useAuthStore()
const notificationStore = useNotificationStore()
const isAdmin = computed(() => authStore.user?.role === 'admin' || authStore.user?.is_admin)
const unreadCount = computed(() => notificationStore.unreadHotNewsCount)
const formattedUnreadCount = computed(() => {
  if (!unreadCount.value || unreadCount.value <= 0) return ''
  return unreadCount.value > 99 ? '99+' : String(unreadCount.value)
})

onMounted(async () => {
  if (authStore.user) {
    try {
      // 通过轻量级接口获取热点新闻未读数量
      const res = await newsApi.getUnreadCount()
      const count = res.data?.unread_count ?? 0
      console.log('[UniversalNavBar] Synced unread count:', count)
      notificationStore.setUnreadCount(count)
    } catch (e) {
      console.error('[UniversalNavBar] Failed to fetch unread count:', e)
    }
  }
})
</script>

<style scoped>
.universal-nav-bar {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
}

.nav-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  max-width: 1400px;
  margin: 0 auto;
  overflow-x: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.3) transparent;
}

.nav-container::-webkit-scrollbar {
  height: 4px;
}

.nav-container::-webkit-scrollbar-track {
  background: transparent;
}

.nav-container::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
}

.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  padding: 0.5rem 0.75rem;
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  border-radius: 8px;
  transition: all 0.3s ease;
  min-width: 60px;
  white-space: nowrap;
  position: relative;
}

.nav-item:hover {
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
  transform: translateY(-2px);
}

.nav-item.router-link-active {
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.nav-item.router-link-active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 30px;
  height: 3px;
  background: #fff;
  border-radius: 2px 2px 0 0;
}

.home-btn {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.home-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.3);
}

.nav-icon {
  width: 20px;
  height: 20px;
  stroke-width: 2;
}

.nav-badge {
  position: absolute;
  top: -6px;
  right: -10px;
  background-color: #ef4444;
  color: #ffffff;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  border-radius: 9999px;
  min-width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  border: 1.5px solid #ffffff;
}

.nav-text {
  font-size: 0.75rem;
  font-weight: 500;
  letter-spacing: 0.5px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .nav-container {
    gap: 0.25rem;
    padding: 0.5rem;
  }

  .nav-item {
    padding: 0.4rem 0.5rem;
    min-width: 50px;
  }

  .nav-icon {
    width: 18px;
    height: 18px;
  }

  .nav-text {
    font-size: 0.7rem;
  }
}

@media (max-width: 480px) {
  .nav-text {
    display: none;
  }

  .nav-item {
    min-width: 40px;
    padding: 0.5rem;
  }

  .nav-icon {
    width: 20px;
    height: 20px;
  }
}

/* 深色模式支持 */
@media (prefers-color-scheme: dark) {
  .universal-nav-bar {
    background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  }
}
</style>
